// "YYYY-MM-DD" in local time (no UTC shift).
export const toDateKey = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

// Parses "YYYY-MM-DD" (or an ISO string) as a local date.
export const parseDateKey = (value) => {
  if (!value) return null;
  const [y, m, d] = String(value).slice(0, 10).split("-").map(Number);
  return new Date(y, m - 1, d);
};

export const isSameDay = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const isSameMonth = (a, b) =>
  a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth();

// The 7 days (Sun -> Sat) of the week containing `date`.
export const getWeekDays = (date) => {
  const start = new Date(date);
  start.setHours(0, 0, 0, 0);
  start.setDate(start.getDate() - start.getDay());

  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    return d;
  });
};

// Mon–Fri days between two "YYYY-MM-DD" dates, inclusive.
export const countWorkingDays = (start, end) => {
  const s = parseDateKey(start);
  const e = parseDateKey(end);
  if (!s || !e || e < s) return 0;

  let count = 0;
  const cursor = new Date(s);
  while (cursor <= e) {
    const day = cursor.getDay();
    if (day !== 0 && day !== 6) count += 1;
    cursor.setDate(cursor.getDate() + 1);
  }
  return count;
};

export const formatTime = (value) => {
  if (!value) return "--:--";

  return new Date(value).toLocaleTimeString("en-PH", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const formatDate = (value) =>
  parseDateKey(value)?.toLocaleDateString("en-PH", {
    month: "short",
    day: "numeric",
    year: "numeric",
  }) ?? "—";

const RELATIVE_UNITS = [
  ["year", 365 * 24 * 3600],
  ["month", 30 * 24 * 3600],
  ["week", 7 * 24 * 3600],
  ["day", 24 * 3600],
  ["hour", 3600],
  ["minute", 60],
];

const relativeFormatter = new Intl.RelativeTimeFormat("en", {
  numeric: "auto",
});

// ISO -> "3 hours ago", "yesterday", ...
export const formatRelative = (iso) => {
  if (!iso) return "—";
  const seconds = (new Date(iso) - Date.now()) / 1000;

  for (const [unit, size] of RELATIVE_UNITS) {
    if (Math.abs(seconds) >= size) {
      return relativeFormatter.format(Math.round(seconds / size), unit);
    }
  }
  return "just now";
};

// 8.5 -> "8h 30m"
export const formatHours = (decimalHours) => {
  const hours = Math.floor(decimalHours);
  const mins = Math.round((decimalHours - hours) * 60);
  return `${hours}h ${mins}m`;
};
